import React, { useEffect, useState } from "react";
import WidgetCard from "./WidgetCard";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllFilters,
  getAllShareFilters,
  getAllTemplateFilters,
  getByDefaultProfileFilters,
  getGlobalBrands,
  getPaneIndex,
  getWidgetGraphObject,
  useQuery,
} from "../../../../redux/constants";
import WidgetHeader from "./Header";
import { useInView } from "react-intersection-observer";
import {
  setPageChart,
  setWidgetMakerGraphData,
  setWidgetMakerShareGraphData,
  setWidgetMakerSharePageGraphData,
} from "../../../../redux/actions/WidgetMaker/WidgetAPI";
import {
  setAggregateData,
  setGraphData,
  setGraphShareFetch,
} from "../../../../redux/actions/ApiCall";
import isEqual from "react-fast-compare";
import WidgetMaker from "../../../WidgetMaker";
import { supportedBenchmarkTraceDashboardTypes } from "../../../../redux/constants/enums";

const Widget = ({
  widget_index,
  data,
  section_index,
  section_id,
  widget,
  onlyWidgets,
  sections,
  widget_id,
  nextWidgetdata,
  prevWidgetdata,
  section,
  isDeepdiveDashboardView = false,
}) => {
  const dispatch = useDispatch();
  let query = useQuery();
  const Section = useSelector((state) => state.Section.addSection);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const graphLoader = useSelector((state) => state.apiCall.loader); //display chart loader
  const panes = useSelector((state) => state.Tab1.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);

  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const sharedDuration = useSelector((state) => state.Share.sharedDuration);
  const index = getPaneIndex(panes, activeKey);
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const sectionLoader = useSelector((state) => state.ApiCall.sectionLoader); //display chart loader

  const widgetLoader = useSelector((state) => state.ApiCall.widgetLoader); //display chart loader
  const widgetUpdateFilterLoader = useSelector(
    (state) => state?.ApiCall?.widget_update_filter_loader
  );
  // const profileFilterList = useSelector(
  //   (state) => state?.apiCall?.profile_filter_list
  // );
  const profileFilterList =
    window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
    window.location.pathname?.split("/")?.[1] === "create-dashboard"
      ? templateDetails?.profile_filters_list
      : panes?.[index]?.profile_filters_list;

  const [realtimeFlag, setRealtimeFlag] = useState({ flag: false, id: null });

  let graphData = data?.graphData || data?.persist_graphdata ? data : widget;

  const { ref, inView, entry } = useInView({
    // trackVisibility: true,
    delay: 10,
    root: document,
    rootMargin: `${window.innerHeight * 0.6}px 20px ${
      window.innerHeight * 0.6
    }px 40px`,
    threshold: 0.0,
  });

  const LoadMoreSections = (
    section_index,
    widget_index,
    data,
    widget,
    entry_id
  ) => {
    let update_entry_id = realtimeFlag?.id ? realtimeFlag?.id : entry_id;
    global.TabActiveKey = null;

    let shareTemplateDataUpdatedList = global.shareTemplateApiCalledList
      ? global.shareTemplateApiCalledList
      : shareTemplateData?.dashboard_called_api_list;

    let templateDetailsApiCalledList = global.templateDetailsApiCalledList
      ? global.templateDetailsApiCalledList
      : templateDetails?.dashboard_called_api_list;

    let pathName = window.location.pathname?.split("/")?.[1];
    // if (
    //   isDeepdiveDashboardView ||
    //   (!shareBrands && panes?.[index]?.isDeepDiveDashboard) ||
    //   (shareBrands && shareTemplateData?.isDeepDiveDashboard)
    // ) {
    //   // Currently by default sections added in deepdive dashboard so this case will not come
    //   // That's why commenting out this
    // } else
    if (
      // profileFilterList &&
      (pathName === "edit-dashboard" || pathName === "create-dashboard") &&
      !shareBrands &&
      ((data && !data?.graphData) || (widget && !widget?.data)) &&
      (!templateDetailsApiCalledList ||
        (templateDetailsApiCalledList &&
          !templateDetailsApiCalledList?.includes(entry_id)))
    ) {
      let sectionObj = {
        filters: templateDetails?.templateFilters,
        quick_filter_value: templateDetails?.quick_filter_value,
        hidden_filter: templateDetails?.hidden_filter,
        adsset_value: templateDetails?.adsset_value,
        ads_value: templateDetails?.ads_value,
      };
      let filter = getAllTemplateFilters(
        graphConditionConfig,
        Section,
        section_index,
        widget_index,
        sectionObj
      );

      let indexes = {
        section_index: section_index >= 0 ? section_index : null,
        templateFilter: true,
        widget_index: widget_index,
        widget_id: widget?.widget_id ? widget?.widget_id : widget_id,
        section: Section,
        graph_type: widget?.graph_type,
        template_details: templateDetails,
        section_id: section_id,
      };

      let sectionObjN = {
        // brand_ids: response?.data?.result?.brand_ids,
        // brand_groups: response?.data?.result?.brand_groups,
        // singleBrands: paneobject?.singleBrands,
        brandFilters: Section?.[section_index ? section_index : 0]?.brandFilters
          ? Section?.[section_index ? section_index : 0]?.brandFilters
          : [],
        filters: Section?.[section_index ? section_index : 0]?.filters
          ? Section?.[section_index ? section_index : 0]?.filters
          : [],
        duration: Section?.[section_index ? section_index : 0]?.duration
          ? Section?.[section_index ? section_index : 0]?.duration
          : null,
        dateFilters: Section?.[section_index ? section_index : 0]?.dateFilters
          ? Section?.[section_index ? section_index : 0]?.dateFilters
          : [],
        is_locked: Section?.[section_index ? section_index : 0]?.is_locked
          ? Section?.[section_index ? section_index : 0]?.is_locked
          : false,
        quick_filter_value: templateDetails?.quick_filter_value,
      };
      let widgetObj = {
        // brand_groups: widget?.brand_groups,
        // singleBrands: paneobject?.singleBrands,
        filters: widget?.filters ? widget?.filters : [],
        duration: {
          from: widget?.start_date
            ? widget?.start_date
            : widget?.dateFilters?.from
            ? widget?.dateFilters?.from
            : null,
          to: widget?.end_date
            ? widget?.end_date
            : widget?.dateFilters?.to
            ? widget?.dateFilters?.to
            : null,
        },
        is_locked: widget?.is_locked ? widget?.is_locked : false,
      };

      let duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : null;

      let global_brands =
        templateDetails?.templateBrands?.columns?.length > 0
          ? templateDetails?.templateBrands?.columns
          : templateDetails?.templateBrands?.length > 0
          ? templateDetails?.templateBrands
          : null;

      // edit dashboard profile filters
      let widget_metadata =
        section_index >= 0
          ? Section?.[section_index]?.data?.[widget_index]
          : Section?.[0]?.data?.[widget_index];

      let widget_profile_filter_list =
        section_index >= 0
          ? Section?.[section_index]?.data?.[widget_index]?.profile_filters_list
          : Section?.[0]?.data?.[widget_index]?.profile_filters_list;

      let defaultProfileFilters;
      if (profileFilterList?.length) {
        defaultProfileFilters = getByDefaultProfileFilters(profileFilterList);
      }

      let obj = {};
      obj.section_index = section_index;
      obj.widget_index = widget_index;
      obj.data = data;

      obj.competition_aggregation =
        supportedBenchmarkTraceDashboardTypes?.includes(
          templateDetails?.template_type
        )
          ? templateDetails?.competition_aggregation || "avg"
          : null;
      obj.template_type = templateDetails?.template_type;
      obj.public_engagement_only =
        templateDetails?.public_engagement_only || false;
      obj.duration = duration;
      obj.global_brands = global_brands;
      obj.filter = filter;
      obj.widget = widget;
      obj.temporary_words = temporary_words;
      obj.brandlogicalgroup = brandlogicalgroup;
      obj.brands = brands;
      obj.graphConditionConfig = graphConditionConfig;
      obj.authParams = authParams;
      obj.sectionObj = sectionObjN;
      obj.widgetObj = widgetObj;
      obj.type = "template";
      obj.profile_filters = widget_metadata?.profile_filters
        ? widget_metadata?.profile_filters
        : defaultProfileFilters;
      obj.profile_filters_list =
        widget_profile_filter_list?.length > 0
          ? widget_profile_filter_list
          : profileFilterList;
      obj.profile_filters_flag = widget_metadata?.profile_filters_flag;
      obj.filter_by_data = widget_metadata?.filter_by_data;
      obj.filter_by = widget_metadata?.filter_by;
      obj.data_source = widget_metadata?.data_source
        ? widget_metadata?.data_source
        : "mentions";

      obj.filter_dropdown = widget_metadata?.filter_dropdown
        ? widget_metadata?.filter_dropdown
        : [];
      obj.filter_by_dropdown = widget_metadata?.filter_by_dropdown
        ? widget_metadata?.filter_by_dropdown
        : [];
      obj.filter_by_dropdown_data = widget_metadata?.filter_by_dropdown_data
        ? widget_metadata?.filter_by_dropdown_data
        : [];
      let widgetGraphObject = getWidgetGraphObject(obj);
      widgetGraphObject.isNetworkChartV2 =
        widgetGraphObject?.chart?.chart_type === "network-graph-v2"
          ? true
          : false;
      if (
        widgetGraphObject?.x_axis ||
        widgetGraphObject?.y_series ||
        widgetGraphObject?.chart
      ) {
        if (
          graphConditionConfig?.[`data-source`]?.includes(
            widgetGraphObject?.data_source
          )
        ) {
          dispatch(setPageChart(authParams, widgetGraphObject, indexes));
        } else {
          dispatch(
            setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
          );
        }
      } else {
        if (authParams) {
          widgetGraphObject && widgetGraphObject?.graph_type === "aggregate"
            ? dispatch(
                setAggregateData(
                  widgetGraphObject,
                  indexes //widget data
                )
              )
            : dispatch(
                setGraphData(
                  widgetGraphObject,
                  indexes //widget data
                )
              );
        }
      }
    } else if (
      // profileFilterList &&
      !widgetUpdateFilterLoader &&
      (pathName === "dashboard" || pathName === "pin-dashboard") &&
      panes?.[index]?.isDashboard &&
      !shareBrands &&
      ((data && !data?.graphData) || (widget && !widget?.data)) &&
      (!panes?.[index]?.dashboard_called_api_list ||
        (panes?.[index]?.dashboard_called_api_list &&
          !panes?.[index]?.dashboard_called_api_list?.includes(
            update_entry_id
          ))) &&
      !panes?.[index]?.is_widget_maker_open_obj?.open_flag // This flag added due to edit widget maker development
    ) {
      let duration = panes[index]?.duration;

      // let global_brands = getGlobalBrands(
      //   panes[index]?.brands,
      //   global_dashboard_single_brands,
      //   global_dashboard_brands,
      //   panes[index]?.template_type
      // );
      let global_brands = panes?.[index]?.brands;

      let sectionObj = {
        filters: templateDetails?.templateFilters,
      };

      let widgetObj = {
        brand_groups: data?.brand_groups,
        singleBrands: brands,
      };

      let filter = getAllFilters(
        graphConditionConfig,
        panes,
        index,
        section_index,
        widget_index,
        brandlogicalgroup,
        data?.brand_ids, //logical brand change
        widgetObj
      );

      let indexes = {
        pane_index: index,
        section_index: onlyWidgets ? null : section_index,
        panes: panes,
        widget_index: widget_index,
        widget_id: widget?.widget_id ? widget?.widget_id : widget_id,
        graph_type: data ? data?.graph_type : widget?.graph_type,
        templateFilter: widget ? true : false,

        section_id: section_id,
      };

      // View Dashboard Case
      let widget_metadata =
        section_index >= 0
          ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
          : panes?.[index]?.section?.[0]?.widgets?.[widget_index];

      let widget_profile_filter_list =
        section_index >= 0
          ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
              ?.profile_filters_list
          : panes?.[index]?.section?.[0]?.widgets?.[widget_index]
              ?.profile_filters_list;

      let defaultProfileFilters;
      if (profileFilterList?.length) {
        defaultProfileFilters = getByDefaultProfileFilters(profileFilterList);
      }

      let obj = {};
      obj.section_index = section_index;
      obj.widget_index = widget_index;
      obj.data = data;
      obj.panes = panes;
      obj.paneIndex = index;
      obj.duration = duration;
      obj.global_brands = global_brands;
      obj.filter = filter;
      obj.widget = widget;
      obj.temporary_words = temporary_words;
      obj.brandlogicalgroup = brandlogicalgroup;
      obj.brands = brands;
      obj.graphConditionConfig = graphConditionConfig;
      obj.authParams = authParams;
      obj.type = "view";
      obj.profile_filters = widget_metadata?.profile_filters
        ? widget_metadata?.profile_filters
        : defaultProfileFilters;
      obj.profile_filters_list =
        widget_profile_filter_list?.length > 0
          ? widget_profile_filter_list
          : profileFilterList;
      obj.profile_filters_flag = widget_metadata?.profile_filters_flag;
      obj.filter_by_data = widget_metadata?.filter_by_data;
      obj.filter_by = widget_metadata?.filter_by;
      obj.data_source = widget_metadata?.data_source
        ? widget_metadata?.data_source
        : "mentions";

      obj.filter_dropdown = widget_metadata?.filter_dropdown
        ? widget_metadata?.filter_dropdown
        : [];
      obj.filter_by_dropdown = widget_metadata?.filter_by_dropdown
        ? widget_metadata?.filter_by_dropdown
        : [];
      obj.filter_by_dropdown_data = widget_metadata?.filter_by_dropdown_data
        ? widget_metadata?.filter_by_dropdown_data
        : [];
      let widgetGraphObject = getWidgetGraphObject(obj);
      widgetGraphObject.isNetworkChartV2 =
        widgetGraphObject?.chart?.chart_type === "network-graph-v2"
          ? true
          : false;

      if (
        widgetGraphObject?.x_axis ||
        widgetGraphObject?.y_series ||
        widgetGraphObject?.chart
      ) {
        if (
          graphConditionConfig?.[`data-source`]?.includes(
            widgetGraphObject?.data_source
          )
        ) {
          dispatch(setPageChart(authParams, widgetGraphObject, indexes));
        } else {
          dispatch(
            setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
          );
        }
      } else {
        if (authParams) {
          widgetGraphObject && widgetGraphObject?.graph_type === "aggregate"
            ? dispatch(
                setAggregateData(
                  widgetGraphObject,
                  indexes //widget data
                )
              )
            : dispatch(
                setGraphData(
                  widgetGraphObject,
                  indexes //widget data
                )
              );
        }
      }
    } else if (
      shareTemplateData &&
      shareBrands &&
      shareCategory &&
      ((data && !data?.graphData) || (widget && !widget?.data)) &&
      (!shareTemplateDataUpdatedList ||
        (shareTemplateDataUpdatedList &&
          !shareTemplateDataUpdatedList?.includes(update_entry_id)))
    ) {
      let duration = {
        // global duration  -->dateData
        from: sharedDuration?.from,
        to: sharedDuration?.to,
      };

      let filter = getAllShareFilters(
        graphConditionConfig,
        shareTemplateData,
        section_index,
        widget_index,
        shareBrands
      );

      let indexes = {
        section_index: section_index,
        widget_index: widget_index,
        shareTemplateData: shareTemplateData,
        section_id: section_id,
        widget_id: widget_id,
      };
      let share = {
        sections: shareTemplateData,
      };

      // Shared Dashboard Case
      let widget_metadata =
        section_index >= 0
          ? shareTemplateData?.sections?.[section_index]?.widgets?.[
              widget_index
            ]
          : shareTemplateData?.section?.[0]?.widgets?.[widget_index];

      let profile_filter =
        section_index >= 0
          ? shareTemplateData?.sections?.[section_index]?.widgets?.[
              widget_index
            ]?.profile_filters
          : shareTemplateData?.section?.[0]?.widgets?.[widget_index]
              ?.profile_filters;

      let widgetDefaultFilters;
      if (widget_metadata?.profile_filters_list?.length) {
        widgetDefaultFilters = {
          columns: [
            {
              name: widget_metadata?.profile_filters_list?.[0]?.id,
              type: "include",
              display_name: widget_metadata?.profile_filters_list?.[0]?.name,
              profile_channel:
                widget_metadata?.profile_filters_list?.[0]?.channel,
              brand_id: widget_metadata?.profile_filters_list?.[0]?.brand_id,
            },
          ],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
      }

      let obj = {};
      obj.type = "share_dashboard";
      obj.section_index = section_index;
      obj.widget_index = widget_index;
      obj.data = data;
      obj.shareTemplateData = shareTemplateData;
      obj.duration = duration;
      //obj.defaultBrands=defaultBrands;
      obj.filter = filter;
      // obj.widget=widget;
      // obj.temporary_words=temporary_words;
      obj.shareBrands = shareBrands;
      obj.graphConditionConfig = graphConditionConfig;
      //obj.authParams = authParams;
      obj.profile_filters = widget_metadata?.profile_filters
        ? widget_metadata?.profile_filters
        : !widget_metadata?.profile_filters &&
          widget_metadata?.is_locked &&
          widgetDefaultFilters
        ? widgetDefaultFilters
        : !widget_metadata?.is_locked && shareTemplateData?.profile_filters;
      // obj.profile_filters_list = profileFilterList;
      obj.profile_filters_flag = widget_metadata?.profile_filters_flag;
      obj.filter_by_data = widget_metadata?.filter_by_data;
      obj.filter_by = widget_metadata?.filter_by;
      obj.data_source = widget_metadata?.data_source
        ? widget_metadata?.data_source
        : "mentions";

      obj.filter_dropdown = widget_metadata?.filter_dropdown
        ? widget_metadata?.filter_dropdown
        : [];
      obj.filter_by_dropdown = widget_metadata?.filter_by_dropdown
        ? widget_metadata?.filter_by_dropdown
        : [];
      obj.filter_by_dropdown_data = widget_metadata?.filter_by_dropdown_data
        ? widget_metadata?.filter_by_dropdown_data
        : [];
      let widgetGraphObject = getWidgetGraphObject(obj);
      widgetGraphObject.isNetworkChartV2 =
        widgetGraphObject?.chart?.chart_type === "network-graph-v2"
          ? true
          : false;

      if (
        widgetGraphObject?.x_axis ||
        widgetGraphObject?.y_series ||
        widgetGraphObject?.chart
      ) {
        graphConditionConfig?.[`data-source`]?.includes(
          widgetGraphObject?.data_source
        )
          ? dispatch(
              setWidgetMakerSharePageGraphData(
                widgetGraphObject,
                shareCategory,
                indexes,
                share,
                query?.get("share_id")
              )
            )
          : dispatch(
              setWidgetMakerShareGraphData(
                widgetGraphObject,
                shareCategory,
                indexes,
                share,
                query?.get("share_id")
              )
            );
      } else {
        dispatch(
          setGraphShareFetch(
            widgetGraphObject,
            shareCategory,
            indexes,
            share,
            query?.get("share_id")
          )
        );
      }
    }
    if (realtimeFlag?.flag) setRealtimeFlag({ flag: false, id: null });
  };
  useEffect(() => {
    if (
      data?.data_source === "realtime" &&
      !data?.graphData &&
      data?.persist_graphdata
    ) {
      setRealtimeFlag({
        flag: true,
        id: widget_id + "#" + section_id + "#" + widget_index,
      });
    }
  }, [panes, shareTemplateData]);

  useEffect(() => {
    if (
      (inView && (!data?.graphData || !widget?.data) && entry?.target?.id) ||
      realtimeFlag?.flag
    ) {
      LoadMoreSections(
        section_index,
        widget_index,
        data,
        widget,
        entry?.target?.id
      );
    }
  }, [
    inView,
    widgetUpdateFilterLoader,
    graphLoader,
    profileFilterList,
    realtimeFlag,
  ]);

  return (
    <>
      {!shareBrands && !isDeepdiveDashboardView ? (
        (graphLoader &&
          widgetLoader?.widget_id === widget_id &&
          !data?.persist_graphdata &&
          widgetLoader?.section_index === section_index &&
          widgetLoader?.widget_index === widget_index) ||
        widgetLoader?.global ||
        (onlyWidgets && data && !data?.graphData && !data?.persist_graphdata) ||
        (onlyWidgets && widget && !widget?.data) ||
        (sectionLoader?.value && sectionLoader?.id === section_id) ||
        (sectionLoader?.value && sectionLoader?.widget_id === widget_id) ? (
          <>
            <div
              className={`col-12 pl-0  ${
                data?.span === "half"
                  ? "col-md-6 widget_half"
                  : data?.span === "one_third"
                  ? "col-md-4 widget_one_third"
                  : data?.span === "two_third"
                  ? "col-md-8 widget_two_third"
                  : "col-md-12 widget_full h-100"
              }`}
            >
              <div
                className={`Dashboard__Widget portlet p-0 mb-15 border-radius-4 ${
                  (sections &&
                    sections?.[section_index ? section_index : 0]?.widgets?.[
                      widget_index
                    ]?.type === "predefined" &&
                    sections?.[section_index ? section_index : 0]?.widgets?.[
                      widget_index
                    ]?.widget_id !== "000-700-001") ||
                  (section &&
                    section?.[section_index ? section_index : 0]?.widgets?.[
                      widget_index
                    ]?.type === "predefined" &&
                    section?.[section_index ? section_index : 0]?.widgets?.[
                      widget_index
                    ]?.widget_id !== "000-700-001") ||
                  (Section &&
                    Section?.[section_index ? section_index : 0]?.data?.[
                      widget_index
                    ]?.type === "predefined" &&
                    Section?.[section_index ? section_index : 0]?.data?.[
                      widget_index
                    ]?.widget_id !== "000-700-001")
                    ? "predefined_border"
                    : ""
                }`}
                ref={ref}
                id={widget_id + "#" + section_id + "#" + widget_index}
              >
                <div
                  ref={ref}
                  id={widget_id + "#" + section_id + "#" + widget_index}
                  className="Dashboard__Widget--header"
                >
                  <WidgetHeader
                    widget_name={
                      data?.widget_name
                        ? data?.widget_name
                        : graphData?.widget_name
                    }
                    widget_description={
                      data?.widget_description
                        ? data?.widget_description
                        : widget?.widget_description
                    }
                    section_id={section_id}
                    widget_id={data?.widget_id ? data?.widget_id : data?.id}
                    widget_index={widget_index}
                    section_index={section_index}
                    graph_type={graphData?.graph_type}
                    chart_type={
                      graphData?.graph_type
                        ? graphData?.graph_type
                        : widget?.chart?.chart_type
                        ? widget?.chart?.chart_type
                        : data?.chart?.chart_type
                    }
                    widgets={graphData}
                    template_widget={
                      data?.graphData || data?.persist_graphdata ? false : true
                    }
                    dashboard={
                      data?.graphData || data?.persist_graphdata ? true : false
                    }
                    sections={sections}
                    allData={graphData}
                    widHeaderLoader={true}
                    pane_section={panes?.[index]?.section}
                    selectedDeepdiveWidget={
                      panes?.[index]?.selected_deepdive_widget
                    }
                    templateAccessType={panes?.[index]?.access_type}
                  />
                </div>
                <div className="Dashboard__Widget--body portlet1 border-0 box-shadow-none">
                  <div
                    className="loader"
                    style={{
                      height:
                        (data?.span === "full" && data?.graph_type === "kpi") ||
                        (graphData?.span === "full" &&
                          graphData?.graph_type === "kpi")
                          ? "15rem"
                          : ((graphData?.span !== "full" &&
                              graphData?.graph_type === "kpi") ||
                              (data?.span !== "full" &&
                                data?.graph_type === "kpi")) &&
                            (nextWidgetdata?.graph_type === "kpi" ||
                              prevWidgetdata?.graph_type === "kpi")
                          ? "15rem"
                          : "45rem",
                    }}
                  >
                    <div
                      ref={ref}
                      className="lds-ring"
                      id={widget_id + "#" + section_id + "#" + widget_index}
                    >
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <WidgetCard
              data={data}
              section_id={section_id}
              widget_index={widget_index}
              section_index={section_index}
              widgets={widget}
              sections={sections}
              widget_id={widget_id}
              nextWidgetdata={nextWidgetdata}
              prevWidgetdata={prevWidgetdata}
              isDeepdiveDashboardView={isDeepdiveDashboardView}
            />
          </>
        )
      ) : (
        <>
          <WidgetCard
            data={data}
            section_id={section_id}
            widget_index={widget_index}
            section_index={section_index}
            widgets={widget}
            sections={sections}
            widget_id={widget_id}
            nextWidgetdata={nextWidgetdata}
            prevWidgetdata={prevWidgetdata}
            isDeepdiveDashboardView={isDeepdiveDashboardView}
          />
        </>
      )}
    </>
  );
};

export default React.memo(Widget, isEqual);
